<!--模板-->
<template>
  <div id="about">
    <!--左侧-->
    <div style="width: 20%;background: #f5f5f5;border-right: solid 1px #e6e6e6">
      <el-row class="tac" style="width: 100%">
        <el-col :span="24">
          <el-menu :default-active="listIndex" class="el-menu-vertical-demo" @select="handleOpen" background-color="#f5f5f5">
            <el-menu-item index="0">
              <i class="el-icon-setting"></i>
              <span slot="title">帮助中心</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-setting"></i>
              <span slot="title">关于我们</span>
            </el-menu-item>
            <el-menu-item index="1">
              <i class="el-icon-setting"></i>
              <span slot="title">用户协议</span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-setting"></i>
              <span slot="title">隐私政策</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-setting"></i>
              <span slot="title">免责声明</span>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <!--右侧内容-->
    <div style="width: 80%;background: #fff;padding: 20px">
      <!--帮助-->
      <div v-if="listIndex == 0">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item title="心愿众筹是什么？" name="1">
            <div>心愿众筹，是一款众筹产品，众筹成功后可使用众筹后金钱去完成心愿；</div>
          </el-collapse-item>
          <el-collapse-item title="如何结伴而行？" name="2">
            <div>在结伴模块发布结伴招募，对方看中后会联系你是否一起结伴而行；</div>
          </el-collapse-item>
          <el-collapse-item title="怎么发布服务技能？" name="3">
            <div>发布服务技能，需要账户认证后，即可免费发布服务技能，供游客购买；</div>
          </el-collapse-item>
          <el-collapse-item title="可以发布哪些技能？" name="4">
            <div>服务技能种类很多，您可在种类技能区详细查看有哪些种类可以选取；</div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!--关于-->
      <div v-if="listIndex == 6">
        <div v-html="tcpData.content"></div>
      </div>
      <!--用户协议-->
      <div v-if="listIndex == 1">
        <div v-html="tcpData.content"></div>
      </div>
      <!--隐私-->
      <div v-if="listIndex == 2">
        <div v-html="tcpData.content"></div>
      </div>
      <!--免责-->
      <div v-if="listIndex == 5">
        <div v-html="tcpData.content"></div>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
import http from 'api/api'
export default {
  data () {
    return {
      listIndex: "1",
      activeName: '1',
      tcpData: '',
      tcpData1: '',
      tcpData2: '',
      tcpData5: '',
      tcpData6: '',
    };
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key)
      http.GET('/jw-function', {
        module: 'article',
        operation: 'getAgreement',
        type: key
      }).then((res) => {
        this.tcpData = res.data
      })
    },
  },
  mounted () {
    if (this.$route.query.type) {
      this.listIndex = this.$route.query.type + ''
      let params = {
        id: this.listIndex
      }
      http.GET('/jw-function', {
        module: 'article',
        operation: 'getAgreement',
        type: 2
      }).then((res) => {
        this.tcpData = res.data
      })

    }
  }
};
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';
#about {
  display: flex;
  width: 1270px;
  margin: 30px auto;
  min-height: 50vh;
  background: #f5f5f5;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue